import router from "@/router";
import store from "@/store/store.js";

const MAP_CONTENT_ROUTES = ["MapContent", "Geofences", "Beacons", "Wayfinding"];

function shouldUpdateRoute() {
  if (!router) {
    return false;
  }
  const currentRoute = router.currentRoute;
  return MAP_CONTENT_ROUTES.includes(currentRoute.name);
}

function buildNewParams() {
  return {
    clientId: store.state.MAP.currentClient,
    siteId: store.state.MAP.currentSite,
    buildingId: store.state.MAP.currentBuilding,
    levelId: store.state.MAP.currentLevel // level id can be undefined for empty buildings
  };
}

function findBuildingIdIfMissing(newParams, currentRoute) {
  if (newParams.buildingId !== undefined) {
    return;
  }

  const currentSite = store.getters["MAP/currentSiteObject"];
  const currentBuilding = currentSite?.properties?.buildings.find(
    (building) => building.properties.fid === currentRoute.params.buildingId
  );

  if (currentBuilding) {
    newParams.buildingId = currentBuilding.properties.fid;
  }
}

function hasRouteParamsChanged(currentRoute, newParams) {
  return Object.keys(newParams).some((key) => currentRoute.params[key] !== newParams[key]);
}

function updateRouteSafely(newParams) {
  try {
    router.replace({ params: newParams }).catch(() => {
      // Silently handle navigation errors
    });
  } catch (err) {
    // Silently handle navigation errors
  }
}

export function updateMapContentRoute() {
  if (!shouldUpdateRoute()) {
    return;
  }

  const currentRoute = router.currentRoute;
  const newParams = buildNewParams();

  findBuildingIdIfMissing(newParams, currentRoute);

  if (hasRouteParamsChanged(currentRoute, newParams)) {
    updateRouteSafely(newParams);
  }
}
